// 金币
import { sendLogClick } from './index'

export default {
  // 金币扣减-扣减
  goldDeclineLogger(data) {
    sendLogClick('smallfox-teacher_62', {
      ...data
    })
  },
  // 金币扣减-扣减明细
  goldDeclineDetailLogger(data) {
    sendLogClick('smallfox-teacher_63', {
      ...data
    })
  }
}